import React, { useEffect, useState } from "react";
import "../Aboutus/Count.css";

const Count = () => {
  const [counts, setCounts] = useState({
    happyClients: 0,
    gardensCompleted: 0,
    dedicatedStaffs: 0,
    awardsAchieved: 0,
  });

  useEffect(() => {
    const targetCounts = {
      happyClients: 2000,
      gardensCompleted: 500,
      dedicatedStaffs: 50,
      awardsAchieved: 20,
    };

    const interval = 20;

    const incrementCounts = () => {
      setCounts((prevCounts) => {
        const updatedCounts = { ...prevCounts };

        Object.keys(targetCounts).forEach((key) => {
          if (prevCounts[key] < targetCounts[key]) {
            updatedCounts[key] = Math.min(
              prevCounts[key] + Math.ceil(targetCounts[key] / 100),
              targetCounts[key]
            );
          }
        });

        return updatedCounts;
      });
    };

    const timer = setInterval(incrementCounts, interval);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="count-section">
      <div className="count-card">
        <h3>{counts.happyClients}+</h3>
        <p className="p-c">Happy Clients</p>
      </div>
      <div className="count-card">
        <h3>{counts.gardensCompleted}+</h3>
        <p className="p-c">Gardens Completed</p>
      </div>
      <div className="count-card">
        <h3>{counts.dedicatedStaffs}+</h3>
        <p className="p-c">Dedicated Staffs</p>
      </div>
      <div className="count-card">
        <h3>{counts.awardsAchieved}+</h3>
        <p className="p-c">Awards Achieved</p>
      </div>
    </div>
  );
};

export default Count;
